export default function Sparkline() {
  return (
    <div className="mt-6 w-full h-[74px] rounded-xl bg-gradient-to-br from-[rgba(52,199,89,0.25)] to-[rgba(26,163,236,0.22)] relative overflow-hidden">
      <div
        className="absolute inset-x-4 inset-y-4 rounded-lg opacity-80"
        style={{
          background: 'linear-gradient(90deg, rgba(25,203,132,0.8) 0%, rgba(36,135,255,0.7) 80%)',
          maskImage: 'linear-gradient(90deg, rgba(0,0,0,0.9) 35%, rgba(0,0,0,0.2))'
        }}
      />
    </div>
  )
}
